package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.AuthResponse
import com.arena_web.data.dto.OAuthLoginRequest
import com.arena_web.domain.repositories.AuthRepository

class OAuthLoginUseCase(private val authRepository: AuthRepository) {

    @Suppress("LongParameterList")
    suspend operator fun invoke(
        provider: String,
        providerId: String,
        email: String,
        fullName: String? = null,
        avatarUrl: String? = null,
        dateOfBirth: String? = null,
        gender: String? = null,
        city: String? = null,
        country: String? = null,
        languages: List<String>? = null,
    ): Result<AuthResponse> {
        val request = OAuthLoginRequest(
            provider = provider,
            providerId = providerId,
            email = email,
            fullName = fullName,
            avatarUrl = avatarUrl,
            dateOfBirth = dateOfBirth,
            gender = gender,
            city = city,
            country = country,
            languages = languages,
        )
        val result = when (provider.uppercase()) {
            "GOOGLE" -> authRepository.oauthGoogle(request)
            "APPLE" -> authRepository.oauthApple(request)
            else -> return Result.failure(Exception("Unsupported OAuth provider: $provider"))
        }
        result.onSuccess { saveAuthSession(it) }
        return result
    }
}
